(function () {
  let lastUrl = location.href;

  function filterChange() {
    const grid = document.querySelector("#product-grid");
    if (!grid) {
      console.warn("Grid not found.");
      return;
    }

    const filler = grid.querySelector(".card-grid-filler");
    if (!filler) {
      console.warn("Filler not found.");
      return;
    }

    requestAnimationFrame(() => {
      const fillerWidth = filler.offsetWidth;
      const gridWidth = grid.offsetWidth;

      if (fillerWidth === 0 || gridWidth === 0) {
        console.warn("Filler or grid width is 0 – skipping");
        return;
      }

      const ratio = fillerWidth / gridWidth;

      if (ratio < 1 / 3) {
        filler.classList.add("show--narrow");
        filler.classList.remove("show--wide");
      } else {
        filler.classList.remove("show--narrow");
        filler.classList.add("show--wide");

      }
    });
  }

  // Observe filter-triggered DOM changes
  const observer = new MutationObserver(() => {
    const newUrl = location.href;
    if (newUrl !== lastUrl) {
      lastUrl = newUrl;
      setTimeout(filterChange, 300);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const mainEl = document.querySelector('main');
    if (!mainEl) {
      console.warn("Main element not found.");
      return;
    }

    observer.observe(mainEl, {
      childList: true,
      subtree: true
    });

    // Initial layout check
    setTimeout(filterChange, 300);

    // Recalculate on window resize
    window.addEventListener('resize', () => {
      // Slight delay to avoid spam during resize
      clearTimeout(window.__resizeFillerCheck);
      window.__resizeFillerCheck = setTimeout(filterChange, 200);
    });
  });
})();
